import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import 'katex/dist/katex.min.css'; // Don't forget the CSS file!

export default function QuestionText({ text }) {
  const formattedText = text.replace(/\\\\/g, '\\');

  return (
    <ReactMarkdown 
      remarkPlugins={[remarkMath]} 
      rehypePlugins={[rehypeKatex, rehypeRaw]}
    >
        {formattedText}
    </ReactMarkdown>
  );
}